import { useEffect, useState, useCallback, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';


import avatar from '../../assets/logo-beta-1.png';
import img_1 from '../../assets/img_1.png';
import img_2 from '../../assets/img_2.png';
import fundo from '../../assets/fundo.jpg';

import site_img_1 from '../../assets/site-img-1.webp';
import img_vero from '../../assets/vero.png';
import img_paygo from '../../assets/paygo-1.png';
import img_pagSeg from '../../assets/pagseg.png';
import img_stone from '../../assets/stone.png';

import img_fundo_azul from '../../assets/fundoAzul.png';

import img_server from '../../assets/server2.jpg';
import img_cadprod from '../../assets/cadprod.webp';
import img_impnota from '../../assets/impnota.webp';
import img_controlecx from '../../assets/controlecx.webp';
import img_whatsapp from '../../assets/img-whatsapp.png';
import { FaCheck, FaCircleCheck, FaCircleInfo, FaCirclePlus, FaLock, FaStar } from 'react-icons/fa6';
import InputMask from 'react-input-mask';
import api from '../../services/api';
import { toast } from 'react-toastify';



import { isMobile } from 'react-device-detect';
import { Tooltip } from 'antd';
import { FiAlertTriangle } from 'react-icons/fi';
import { safeStr } from '../../services/utils';
import { BCombo2, BComboOp, BCombo, BNum } from '../../components/BeiTec';

const PhoneInput = ({ className, ...props }) => {
  const [mask, setMask] = useState("(99) 99999-9999");

  return (
    <InputMask
      {...props}
      mask={mask}
      onBlur={e => {
        if (e.target.value.replace("_", "").length === 14) {
          setMask("(99) 9999-9999");
        }
      }}
      onFocus={e => {
        if (e.target.value.replace("_", "").length === 14) {
          setMask("(99) 99999-9999");
        }
      }}
    >
      {inputProps => <input {...inputProps} type="tel" />}
    </InputMask>
  );
};


export default function Planos({ children, name }) {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [nome, setNome] = useState("");
  const [isMobile, setIsMobile] = useState(false);
  const [hwidth, setHwidth] = useState(window.innerWidth);
  const [contatoPage, setContatoPage] = useState(1);
  const [isWhats, setIsWhats] = useState(false);
  const [showDiv, setShowDiv] = useState(false);
  const [info, setInfo] = useState("");

  const [limiteEstoque, setLimiteEstoque] = useState(1);
  const [limiteDisp, setLimiteDisp] = useState(2);

  const [limiteTef, setLimiteTef] = useState(0);
  const [limiteSmartTef, setLimiteSmartTef] = useState(0);
  const [limiteLoja, setLimiteLoja] = useState(1);
  const [limiteConsig, setLimiteConsig] = useState(1);

  const [comp_nfe, setComp_nfe] = useState(0);
  const [comp_nfce, setComp_nfce] = useState(1);
  const [comp_nfse_g, setComp_nfse_g] = useState(0);
  const [comp_nfse_p, setComp_nfse_p] = useState(0);
  const [comp_enc, setComp_enc] = useState(0);
  const [comp_ficha, setComp_ficha] = useState(0);
  const [comp_com, setComp_com] = useState(0);
  const [comp_orc, setComp_orc] = useState(0);
  const [comp_conv, setComp_conv] = useState(0);
  const [comp_crediario, setComp_crediario] = useState(0);
  const [comp_etiq, setComp_etiq] = useState(0);
  const [comp_portal_cont, setComp_portal_cont] = useState(0);
  const [comp_env_loja, setComp_env_loja] = useState(0);
  const [comp_boleto, setComp_boleto] = useState(0);
  const [comp_age, setComp_age] = useState(0);

  const [total, setTotal] = useState(50.0);

  const [varValorMenor, setVarValorMenor] = useState(10);


  function calcTotal() {
    let tot = 0.0;

    tot += limiteLoja * 50;

    let disp_gratis = limiteLoja * 2
    let disp_pagos = limiteDisp - disp_gratis
    if (disp_pagos > 0) {
      tot += disp_pagos * 15
    }

    tot += limiteSmartTef * 15;

    tot += limiteTef * 135;

    if (limiteEstoque == 1) {
      tot += 0;
    } else if (limiteEstoque == 2) {
      tot += 5;
    } else if (limiteEstoque == 3) {
      tot += 10;
    } else if (limiteEstoque == 4) {
      tot += 15;
    } else if (limiteEstoque == 5) {
      tot += 20;
    } else if (limiteEstoque == 6) {
      tot += 25;
    }


    let valor_menor = varValorMenor;

    if (comp_nfe == 1) { tot += 0 }
    if (comp_nfce == 1) { tot += 0 }
    if (comp_nfse_g == 1) { tot += valor_menor }
    if (comp_nfse_p == 1) { tot += valor_menor }
    if (comp_enc == 1) { tot += valor_menor }
    if (comp_ficha == 1) { tot += valor_menor }
    if (comp_com == 1) { tot += 10 }
    if (comp_orc == 1) { tot += valor_menor }
    if (comp_conv == 1) { tot += valor_menor }
    if (comp_crediario == 1) { tot += valor_menor }
    if (comp_etiq == 1) { tot += valor_menor }
    if (comp_portal_cont == 1) { tot += 20 }
    if (comp_env_loja == 1) { tot += valor_menor }
    if (comp_boleto == 1) { tot += 25 }
    if (comp_age == 1) { tot += 20 }

    if (limiteConsig == 1) {
      tot += 0;
    } else if (limiteConsig == 2) {
      tot += 15;
    } else if (limiteConsig == 3) {
      tot += 25;
    } else if (limiteConsig == 4) {
      tot += 35;
    }


    setTotal(tot);
  }

  useEffect(() => {
    calcTotal();
  }, [
    limiteEstoque,
    limiteDisp,
    limiteTef,
    limiteSmartTef,
    limiteLoja,
    limiteConsig,
    comp_nfe,
    comp_nfce,
    comp_nfse_g,
    comp_nfse_p,
    comp_enc,
    comp_ficha,
    comp_com,
    comp_orc,
    comp_conv,
    comp_crediario,
    comp_etiq,
    comp_portal_cont,
    comp_env_loja,
    comp_boleto,
    comp_age
  ]);


  useEffect(() => {
    function handleResize() {
      setHwidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [hwidth]);

  useEffect(() => {
    let temp_hwidth = hwidth;
    if (temp_hwidth < 620) {
      if (!isMobile) { setIsMobile(true) }
    } else {
      if (isMobile) { setIsMobile(false) }

    }
    // toast.success(temp_hwidth)
  }, [hwidth]);

  function apenasNumeros(_string) {
    if (_string.match(/^[0-9\-\_\(\)\" "]+$/) != null) {
      return true;
    } else {
      return false;
    }
  }


  useEffect(() => {
    if (email.length >= 2 && apenasNumeros(email) == true) {
      if (isWhats == false) {
        setIsWhats(true);
      }
    } else {
      if (isWhats == true) {
        setIsWhats(false);
      }
    }
  }, [email]);


  function enviarForm(estado = "") {
    setContatoPage(4)
    envia(estado);
  }

  function contato(id = "", autoFocus = false) {


    return (<>
      <div className="fundo" >

        <div className="info-box" style={{ width: "auto", minWidth: "410px", height: "auto" }}>
          <div className="col_a">
            {contatoPage <= 1 && <>
              <img width="64" height="64"
                src="https://img.icons8.com/external-nawicon-outline-color-nawicon/64/external-Agreement-business-management-nawicon-outline-color-nawicon.png" />
            </>}
            {contatoPage == 2 && <>
              <img width="64" height="64" src="https://img.icons8.com/fluency/48/company.png" alt="company" />
            </>}
          </div>
          <div className="col_full">
            <div className="sibe-content-title" style={{ width: "auto", textAlign: "center" }}>
              {contatoPage == 1 ? <>
                <p className="title-bar-texto" style={{ color: "black", fontSize: "16px" }}>Nós entramos em contato com você!</p>
                <div className="edit-mail">
                  {email.length <= 1 ? <>
                    <img width="30" height="30" src="https://img.icons8.com/color/48/chat--v1.png" alt="chat--v1" />
                  </> :
                    email.length >= 2 && apenasNumeros(email) == true ? <>
                      <img width="30" height="30" src="https://img.icons8.com/color/48/whatsapp--v1.png" style={{ marginTop: "-1px" }} />
                    </> : <>
                      <img width="28" height="28" src="https://img.icons8.com/fluency/48/mail.png" style={{ marginLeft: "2px" }} />
                    </>}

                  {isWhats ? <>
                    <PhoneInput name={id} id={id} style={{ textAlign: "center", border: "none", width: "100%" }} value={email} onChange={e => { setEmail(e.target.value) }} autoFocus={autoFocus} />
                  </> : <>
                    <input name={id} id={id} className="edit-mail-input" style={{ textAlign: "center" }}
                      value={email} onChange={e => { setEmail(e.target.value) }} placeholder='informe seu WhatsApp ou Email' />
                  </>}



                  <button className='btn-ok' onClick={() => { if (email.length > 5) { setContatoPage(2) } }} >OK</button>
                </div>
              </> : contatoPage == 2 ? <>
                <p className="title-bar-texto" style={{ color: "black", fontSize: "16px" }}>Qual o nome da sua empresa?</p>
                <div className="edit-mail">
                  <input className="edit-mail-input" style={{ textAlign: "center", margin: "5px" }}
                    value={nome} onChange={e => { setNome(e.target.value) }} placeholder='nome da empresa' />

                  <button className='btn-ok' onClick={() => { if (nome.length > 2) { setContatoPage(3); } }} >OK</button>
                </div>
              </> : contatoPage == 3 ? <>
                <p className="title-bar-texto" style={{ color: "black", fontSize: "16px" }}>Para conluir, clique no estado de atuação.</p>
                <div className="seletor-estado">
                  <button className="btn-estado" onClick={() => { enviarForm("AC") }} >AC</button>
                  <button className="btn-estado" onClick={() => { enviarForm("AL") }} >AL</button>
                  <button className="btn-estado" onClick={() => { enviarForm("AP") }} >AP</button>
                  <button className="btn-estado" onClick={() => { enviarForm("AM") }} >AM</button>
                  <button className="btn-estado" onClick={() => { enviarForm("BA") }} >BA</button>
                  <button className="btn-estado" onClick={() => { enviarForm("CE") }} >CE</button>
                  <button className="btn-estado" onClick={() => { enviarForm("DF") }} >DF</button>
                  <button className="btn-estado" onClick={() => { enviarForm("ES") }} >ES</button>
                  <button className="btn-estado" onClick={() => { enviarForm("GO") }} >GO</button>
                  <button className="btn-estado" onClick={() => { enviarForm("MA") }} >MA</button>
                  <button className="btn-estado" onClick={() => { enviarForm("MT") }} >MT</button>
                  <button className="btn-estado" onClick={() => { enviarForm("MS") }} >MS</button>
                  <button className="btn-estado" onClick={() => { enviarForm("MG") }} >MG</button>
                  <button className="btn-estado" onClick={() => { enviarForm("PA") }} >PA</button>
                  <button className="btn-estado" onClick={() => { enviarForm("PB") }} >PB</button>
                  <button className="btn-estado" onClick={() => { enviarForm("PR") }} >PR</button>
                  <button className="btn-estado" onClick={() => { enviarForm("PI") }} >PI</button>
                  <button className="btn-estado" onClick={() => { enviarForm("RJ") }} >RJ</button>
                  <button className="btn-estado" onClick={() => { enviarForm("RN") }} >RN</button>
                  <button className="btn-estado" onClick={() => { enviarForm("RS") }} >RS</button>
                  <button className="btn-estado" onClick={() => { enviarForm("RO") }} >RO</button>
                  <button className="btn-estado" onClick={() => { enviarForm("RR") }} >RR</button>
                  <button className="btn-estado" onClick={() => { enviarForm("SC") }} >SC</button>
                  <button className="btn-estado" onClick={() => { enviarForm("SP") }} >SP</button>
                  <button className="btn-estado" onClick={() => { enviarForm("SE") }} >SE</button>
                  <button className="btn-estado" onClick={() => { enviarForm("TO") }} >TO</button>
                </div>
              </> : <div style={{ height: "100px", width: "420px", display: "flex", flexDirection: "column", justifyContent: 'center', alignItems: "center", gap: "20px" }}>

                <p>Obrigado, em breve entraremos em contato.</p>
                <img width="48" height="48" src="https://img.icons8.com/color/48/checked--v1.png" alt="checked--v1" />
              </div>

              }

            </div>
          </div>
        </div>
      </div>
    </>)
  }

  function itemT(nome, cor) {
    return (<>
      <div style={{
        width: "auto", maxHeight: "20px", display: "flex", borderRadius: "10px", padding: "11px",
        justifyContent: "center", alignItems: "center", backgroundColor: cor, color: "white"
      }}>
        {nome}
      </div>
    </>)
  }

  async function envia(uf) {
    try {
      const resp = await api.post(`/beitecForm`, {
        code: String("SITE_MAIN"),
        form: String("A00001"),
        nome: String(nome),
        email: String(email),
        fone: String(""),
        whats: String(email),
        aux_a: String('concordo'),
        aux_b: String(uf),
      });
      //alert(JSON.stringify(resp.data));
      if ((resp.data.message) == "OK") {
        return;
      }
    } catch (e) {
      // toast.error('Erro.. '+e);
    }
  }

  function boxRoxo(texto, corA = "#5b45aa", corB = "#5329ec", corC = "#473979") {
    return (<div style={{
      width: isMobile ? "150px" : "200px", height: isMobile ? "110px" : "150px", padding: "10px", display: "flex", background: 'linear-gradient(45deg, ' + corA + ', ' + corB + ', ' + corC + ')',
      justifyContent: "center", alignItems: "center", textAlign: "center", borderRadius: "10px"
    }}>
      <p style={{ color: "white", fontSize: isMobile ? "15px" : "20px", }}>{texto}</p>

    </div>)
  }

  function novoItem(tipo = 1, texto = "", hint = "", extra = "") {
    return (<div style={{ width: "100%", display: "flex", gap: "5px", justifyContent: "space-between" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        {tipo == 4 ?
          <FaCirclePlus size={20} color={'rgb(22, 177, 14)'} style={{ marginLeft: "-0.52px" }} /> :
          <FaCircleCheck size={20} color={tipo == 2 ? 'rgb(105, 137, 177)' : tipo == 4 ? 'rgb(218, 213, 80)' : 'rgb(105, 137, 177)'} />
        }
      </div>

      <div style={{ display: "flex", alignItems: "center", justifyContent: "start", width: "100%" }}>{texto}</div>

      {extra.length > 0 && <>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "start", height: "100%" }}>
          <p style={{ fontSize: "10px", lineHeight: "0.9", textAlign: "end", color: "rgb(12, 55, 104)", marginTop: "2px" }} >{extra}</p></div>
      </>}

      <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>{hint.length > 0 && <Tooltip title={hint} >
        {tipo == 3 ?
          <FaLock style={{ cursor: "help" }} size={18} color='rgb(234, 129, 1)' />
          :
          <FaCircleInfo style={{ cursor: "help" }} size={18} color='rgb(1, 106, 234)' />
        }
      </Tooltip>}  </div>
    </div>)
  }

  function novoModulo(texto = "", hint = "") {
    return (<div style={{ width: "auto", display: "flex", gap: "5px", padding: "3px", justifyContent: "space-between", border: "1px solid black", borderRadius: "4px" }}>
      {/* <div style={{ display:"flex", alignItems:"center", justifyContent:"center" }}><FaCircleCheck size={16} color={'rgb(63, 168, 74)'} /></div> */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "start", width: "100%", fontSize: "11px" }}>{texto}</div>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>{hint.length > 0 && <Tooltip title={hint} >

        <FaCircleInfo style={{ cursor: "help" }} size={15} color='rgb(1, 106, 234)' />

      </Tooltip>}  </div>
    </div>)
  }


  return (
    <>

      <div className="app-content" >

        <img src={img_fundo_azul} style={{ position: "absolute", width: "100%", height: "100%", objectFit: "fill", objectPosition: "10% 45%", zIndex: -1 }} />

        <div style={showDiv ? {} : {
          position: "absolute", right: 0, bottom: 0, margin: "15px", marginRight: "45px", marginBottom: "50px", cursor: "pointer", zIndex: 999999,
        }}
          onClick={() => { window.open("https://api.whatsapp.com/send?phone=555195555616", "WhatsApp"); }}>
          <div style={{
            backgroundColor: "rgb(35, 74, 35)", height: "45px", gap: "10px", width: "100%", textAlign: "center", paddingLeft: "18px", borderRadius: "18px",
            paddingRight: "18px", display: "flex", alignItems: "center", color: "white", border: "2px solid rgb(55, 131, 46)", justifyContent: "space-between"
          }}

          ><img src={img_whatsapp} style={{ width: "42px", height: "42px", top: "calc(100% - 95px)", left: 0, }} />Fale com um consultor</div>
        </div>

        <div className="title-bar" style={{ backgroundColor: "white", display: "flex", justifyContent: "space-between" }}>
          {/*  <div className="sibe-content-avatar"><img src={avatar}  ></img>  </div> */}
          <div className="sibe-content-title">
            <p className="title-bar-texto" style={{ color: "#46619D", fontSize: "28px", cursor: "pointer" }} onClick={() => { navigate("/") }}>BeiTec</p>

          </div>
          <div style={{
            backgroundColor: "rgb(71, 36, 123)", margin: "8px", marginRight: "15px", textAlign: "center", paddingLeft: "28px", borderRadius: "18px", width: "200px",
            paddingRight: "28px", display: "flex", alignItems: "center", textAlign: "center", cursor: "pointer", color: "white", border: "2px solid rgb(103, 24, 223)"
          }}
            onClick={() => { window.open("https://api.whatsapp.com/send?phone=555195555616", "WhatsApp"); }}
          ><p style={{ width: "100%" }}>Quero saber mais</p></div>
        </div>



        <div style={{ margin: "25px", marginBottom: "50px" }}>
          <div>Calculadora de Preços</div>
          <div>
            <div style={{ margin: "15px", fontSize: "20px" }}>TOTAL: R$ {total} mês</div>
            <div style={{ margin: "15px", fontSize: "20px" }}>Vendedor fica com (50%) no 1º mês {total * 0.50}</div>
            <div style={{ margin: "15px", fontSize: "20px" }}>Vendedor fica com (30%) a partir do 2º mês R$ {total * 0.30}</div>

            <div style={{ margin: "15px", fontSize: "20px" }}>BeiTec: R$ {total - (total * 0.30)} mês</div>

            <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>

              <div className='lista-complementos'>
                <BNum titulo={"Lojas"} height={"35px"} width={"130px"} value={limiteLoja} setValue={setLimiteLoja} max={200} min={1} />
                <p>R$ 50,00 por loja</p>
              </div>

              <div className='lista-complementos'>
                <BNum titulo={"Dispositivos"} height={"35px"} width={"130px"} value={limiteDisp} setValue={setLimiteDisp} max={200} min={1} />
                <p>Cada loja inclui 2 dispositivos grátis, cada adicional é cobrado R$ 15,00</p>
              </div>

              <div className='lista-complementos'>
                <BNum titulo={"Smart TEF"} height={"35px"} width={"130px"} value={limiteSmartTef} setValue={setLimiteSmartTef} max={200} min={0} />
                <p>Integrado com PagSeguro/PagBank, Vero/Banrisul, Stone, Cielo*, MercadoPago*</p>
                <p>R$ 20,00</p>
              </div>

              <div className='lista-complementos'>
                <BNum titulo={"TEF PIN-PAD (antigo)"} height={"35px"} width={"130px"} value={limiteTef} setValue={setLimiteTef} max={200} min={0} />
                <p>Integrado com PayGO. R$ 135,00</p>
              </div>


              <div className='lista-complementos'>
                <BCombo2 modelo={3} titulo='Limite de Cadastros no Estoque' width={"180px"} modoAberto={true} value={limiteEstoque} width={"auto"}>
                  <BComboOp modoAberto={true} check={limiteEstoque == 1} value={1} onClick={(e) => { setLimiteEstoque(e) }}>1.000</BComboOp>
                  <BComboOp modoAberto={true} check={limiteEstoque == 2} value={2} onClick={(e) => { setLimiteEstoque(e) }}>5.000</BComboOp>
                  <BComboOp modoAberto={true} check={limiteEstoque == 4} value={4} onClick={(e) => { setLimiteEstoque(e) }}>30.000</BComboOp>
                  <BComboOp modoAberto={true} check={limiteEstoque == 5} value={5} onClick={(e) => { setLimiteEstoque(e) }}>60.000</BComboOp>
                  <BComboOp modoAberto={true} check={limiteEstoque == 6} value={6} onClick={(e) => { setLimiteEstoque(e) }}>100.000</BComboOp>
                </BCombo2>
                <p>Quantidade de cadastros idepende da quantidade de lojas</p>
              </div>

              <div className='lista-complementos'>
                <div style={{ width: "100%" }}>
                  <p>Vale para todas as lojas do grupo</p>
                </div>
                <div className={`comple-item ${comp_nfe == 1 && "item-sel"} `} onClick={() => { setComp_nfe(comp_nfe == 1 ? 0 : 1) }}>
                  <p style={{ whiteSpace: 'nowrap' }}>NFe (DANFE A4)</p><p style={{ color: "green", fontSize: "11px", fontWeight: 800 }}>INCLUSO</p>
                </div>
                <div className={`comple-item ${comp_nfce == 1 && "item-sel"} `} onClick={() => { setComp_nfce(comp_nfce == 1 ? 0 : 1) }}>
                  <p style={{ whiteSpace: 'nowrap' }}>NFCe (CUPOM)</p><p style={{ color: "green", fontSize: "11px", fontWeight: 800 }}>INCLUSO</p>
                </div>
                <div className={`comple-item ${comp_nfse_g == 1 && "item-sel"} `} onClick={() => { setComp_nfse_g(comp_nfse_g == 1 ? 0 : 1) }}>
                  <p style={{ whiteSpace: 'nowrap' }}>NFSe (GUAIBA/RS)</p><p style={{ color: "green", fontSize: "11px", fontWeight: 800 }}>+ R$ {varValorMenor}</p>
                </div>
                <div className={`comple-item ${comp_nfse_p == 1 && "item-sel"} `} onClick={() => { setComp_nfse_p(comp_nfse_p == 1 ? 0 : 1) }}>
                  <p style={{ whiteSpace: 'nowrap' }}>NFSe (PORTO ALEGRE/RS)</p><p style={{ color: "green", fontSize: "11px", fontWeight: 800 }}>+ R$ {varValorMenor}</p>
                </div>
                <div className={`comple-item ${comp_enc == 1 && "item-sel"} `} onClick={() => { setComp_enc(comp_enc == 1 ? 0 : 1) }}>
                  <p style={{ whiteSpace: 'nowrap' }}>Encomendas Cliente</p><p style={{ color: "green", fontSize: "11px", fontWeight: 800 }}>+ R$ {varValorMenor}</p>
                </div>
                <div className={`comple-item ${comp_ficha == 1 && "item-sel"} `} onClick={() => { setComp_ficha(comp_ficha == 1 ? 0 : 1) }}>
                  <p style={{ whiteSpace: 'nowrap' }}>Venda em Ficha (crédito)</p><p style={{ color: "green", fontSize: "11px", fontWeight: 800 }}>+ R$ {varValorMenor}</p>
                </div>
                <div className={`comple-item ${comp_com == 1 && "item-sel"} `} onClick={() => { setComp_com(comp_com == 1 ? 0 : 1) }}>
                  <p style={{ whiteSpace: 'nowrap' }}>Comandas</p><p style={{ color: "green", fontSize: "11px", fontWeight: 800 }}>+ R$ {varValorMenor}</p>
                </div>
                <div className={`comple-item ${comp_orc == 1 && "item-sel"} `} onClick={() => { setComp_orc(comp_orc == 1 ? 0 : 1) }}>
                  <p style={{ whiteSpace: 'nowrap' }}>Orçamentos</p><p style={{ color: "green", fontSize: "11px", fontWeight: 800 }}>+ R$ {varValorMenor}</p>
                </div>
                <div className={`comple-item ${comp_conv == 1 && "item-sel"} `} onClick={() => { setComp_conv(comp_conv == 1 ? 0 : 1) }}>
                  <p style={{ whiteSpace: 'nowrap' }}>Convênio</p><p style={{ color: "green", fontSize: "11px", fontWeight: 800 }}>+ R$ {varValorMenor}</p>
                </div>
                <div className={`comple-item ${comp_crediario == 1 && "item-sel"} `} onClick={() => { setComp_crediario(comp_crediario == 1 ? 0 : 1) }}>
                  <p style={{ whiteSpace: 'nowrap' }}>Crediário</p><p style={{ color: "green", fontSize: "11px", fontWeight: 800 }}>+ R$ {varValorMenor}</p>
                </div>
                <div className={`comple-item ${comp_etiq == 1 && "item-sel"} `} onClick={() => { setComp_etiq(comp_etiq == 1 ? 0 : 1) }}>
                  <p style={{ whiteSpace: 'nowrap' }}>Criador de Etiquetas</p><p style={{ color: "green", fontSize: "11px", fontWeight: 800 }}>+ R$ {varValorMenor}</p>
                </div>
                <div className={`comple-item ${comp_portal_cont == 1 && "item-sel"} `} onClick={() => { setComp_portal_cont(comp_portal_cont == 1 ? 0 : 1) }}>

                  <p style={{ whiteSpace: 'nowrap' }}>Portal de acesso contador</p><p style={{ color: "green", fontSize: "11px", fontWeight: 800 }}>+ R$ 25,00</p>
                </div>
                <div className={`comple-item ${comp_env_loja == 1 && "item-sel"} `} onClick={() => { setComp_env_loja(comp_env_loja == 1 ? 0 : 1) }}>
                  <p style={{ whiteSpace: 'nowrap' }}>Envio facil entre lojas</p><p style={{ color: "green", fontSize: "11px", fontWeight: 800 }}>+ R$ 15,00</p>
                </div>
                <div className={`comple-item ${comp_boleto == 1 && "item-sel"} `} onClick={() => { setComp_boleto(comp_boleto == 1 ? 0 : 1) }}>
                  <p style={{ whiteSpace: 'nowrap' }}>Criação de Boleto & PIX cobrança</p><p style={{ color: "green", fontSize: "11px", fontWeight: 800 }}>+ R$ 25,00</p>
                </div>
                <div className={`comple-item ${comp_age == 1 && "item-sel"} `} onClick={() => { setComp_age(comp_age == 1 ? 0 : 1) }}>
                  <p style={{ whiteSpace: 'nowrap' }}>Agendamentos</p><p style={{ color: "green", fontSize: "11px", fontWeight: 800 }}>+ R$ 20,00</p>
                </div>
              </div>

              {/*
                <BCombo2 modelo={2} titulo='Verificador de Preços' disabled={true} width={"180px"} modoAberto={true} value={1} width={"auto"}>
                  <BComboOp modoAberto={true} check={true} >(SEM)</BComboOp>
                  <BComboOp modoAberto={true} check={false} >Por Produto 1a1</BComboOp>
                  <BComboOp modoAberto={true} check={false} >Relatório Geral e 1a1</BComboOp>
                </BCombo2>
                */}
              <div className='lista-complementos'>
                <BCombo2 modelo={3} titulo='Controle de Consingados' width={"180px"} modoAberto={true} value={limiteConsig} width={"100%"}>
                  <BComboOp modoAberto={true} check={limiteConsig == 1} value={1} onClick={(e) => { setLimiteConsig(e) }}>(SEM)</BComboOp>
                  <BComboOp modoAberto={true} check={limiteConsig == 2} value={2} onClick={(e) => { setLimiteConsig(e) }}>F20 & C20</BComboOp>
                  <BComboOp modoAberto={true} check={limiteConsig == 3} value={3} onClick={(e) => { setLimiteConsig(e) }}>F80 & C80</BComboOp>
                  <BComboOp modoAberto={true} check={limiteConsig == 4} value={4} onClick={(e) => { setLimiteConsig(e) }}>F120 & C120</BComboOp>
                </BCombo2>
              </div>

            </div>
          </div>
        </div>


        <div className='fundo_tables' style={{ zIndex: 1222, height: "auto", minHeight: "500px", width: "100%", gap: "25px", padding: "25px" }}>

          <div style={{ border: "1px solid black", borderRadius: "10px" }}>
            <p style={{ margin: "10px", fontSize: "15px" }} >Planos ERP BeiTec</p>
            <table className='table_princ' style={{ height: "auto", overflow: "hidden" }}>
              <thead>
                <tr>
                  <th></th>

                  <th><p style={{ fontSize: "19px" }}>Micro</p><div style={{ fontSize: "12px", whiteSpace: "nowrap", display: "flex", gap: "2px" }}>
                    <p style={{ fontSize: "15px" }}>R$ 50,00</p>
                    <p style={{ fontSize: "11px", color: "rgb(54, 81, 109)", maxWidth: "20px", marginTop: "3px" }}>mês</p>
                  </div></th>

                  <th><p style={{ fontSize: "19px" }}>Médio</p><div style={{ fontSize: "12px", whiteSpace: "nowrap", display: "flex", gap: "2px" }}>
                    <p style={{ fontSize: "15px" }}>R$ 65,00</p>
                    <p style={{ fontSize: "11px", color: "rgb(54, 81, 109)", maxWidth: "20px", marginTop: "3px" }}>mês</p>
                  </div></th>

                  <th><p style={{ fontSize: "19px" }}>Pró</p><div style={{ fontSize: "12px", whiteSpace: "nowrap", display: "flex", gap: "2px" }}>
                    <p style={{ fontSize: "15px" }}>R$ 95,00</p>
                    <p style={{ fontSize: "11px", color: "rgb(54, 81, 109)", maxWidth: "20px", marginTop: "3px" }}>mês</p>
                  </div></th>

                  <th><p style={{ fontSize: "19px" }}>Ultra</p><div style={{ fontSize: "12px", whiteSpace: "nowrap", display: "flex", gap: "2px" }}>
                    <p style={{ fontSize: "15px" }}>R$ 125,00</p>
                    <p style={{ fontSize: "11px", color: "rgb(54, 81, 109)", maxWidth: "20px", marginTop: "3px" }}>mês</p>
                  </div></th>

                </tr>
              </thead>
              <tbody>
                <tr>

                  <td style={{ textAlign: "left", fontSize: "13px" }}>
                    <Tooltip title="Dispositivo pode ser um tablet, celular, notebook, computador, desde que tenha um navegador de internet. Cada plano vem com um limite de dispositivos, você pode adicionar mais dispositivos, confira os valores de dispositivo adicional na tabela de complementos.">
                      <div style={{ width: "100%", position: "relative" }}> Dispositivos ao mesmo tempo
                        <div style={{ cursor: "help", position: "absolute", right: 0, top: 0, fontWeight: 700, color: "blue" }}>?</div> </div>
                    </Tooltip> </td>
                  <td>1+</td>
                  <td>2+</td>
                  <td>3+</td>
                  <td>3+</td>
                </tr>
                <tr>
                  <td style={{ textAlign: "left", fontSize: "13px" }}>Limite de Usuários</td>
                  <td>Até 2</td>
                  <td>Sem Limite</td>
                  <td>Sem Limite</td>
                  <td>Sem Limite</td>
                </tr>
                <tr>
                  <td style={{ textAlign: "left", fontSize: "13px" }}>Cadastros de Produtos</td>
                  <td>Até 1.000</td>
                  <td>Até 10.000</td>
                  <td>Até 30.000</td>
                  <td>Até 60.000</td>
                </tr>
                <tr>
                  <td style={{ textAlign: "left", fontSize: "13px" }}>Controle de Estoque</td>
                  <td><FaCheck size={26} color='green' /></td>
                  <td><FaCheck size={26} color='green' /></td>
                  <td><FaCheck size={26} color='green' /></td>
                  <td><FaCheck size={26} color='green' /></td>
                </tr>
                <tr>
                  <td style={{ textAlign: "left", fontSize: "13px" }}>Emite NFe, NFCe</td>
                  <td><FaCheck size={26} color='green' /></td>
                  <td><FaCheck size={26} color='green' /></td>
                  <td><FaCheck size={26} color='green' /></td>
                  <td><FaCheck size={26} color='green' /></td>
                </tr>
                <tr>
                  <td style={{ textAlign: "left", fontSize: "13px" }}><Tooltip title="Confira o valor da loja adicional na tabela complementos" >
                    <div style={{ width: "100%", position: "relative" }}>Multi Loja
                      <div style={{ cursor: "help", position: "absolute", right: 0, top: 0, fontWeight: 700, color: "blue" }}>?</div></div></Tooltip></td>
                  <td>-</td>
                  <td><FaCheck size={26} color='green' /></td>
                  <td><FaCheck size={26} color='green' /></td>
                  <td><FaCheck size={26} color='green' /></td>
                </tr>
                <tr>
                  <td style={{ textAlign: "left", fontSize: "13px" }}>Encomendas de Cliente</td>
                  <td><FaCheck size={26} color='green' /></td>
                  <td><FaCheck size={26} color='green' /></td>
                  <td><FaCheck size={26} color='green' /></td>
                  <td><FaCheck size={26} color='green' /></td>
                </tr>
                <tr>
                  <td style={{ textAlign: "left", fontSize: "13px" }}>Venda em Ficha (caderninho)</td>
                  <td><FaCheck size={26} color='green' /></td>
                  <td><FaCheck size={26} color='green' /></td>
                  <td><FaCheck size={26} color='green' /></td>
                  <td><FaCheck size={26} color='green' /></td>
                </tr>
                <tr>
                  <td style={{ textAlign: "left", fontSize: "13px" }}>Caixa (estilo PDV)</td>
                  <td><FaCheck size={26} color='green' /></td>
                  <td><FaCheck size={26} color='green' /></td>
                  <td><FaCheck size={26} color='green' /></td>
                  <td><FaCheck size={26} color='green' /></td>
                </tr>
                <tr>
                  <td style={{ textAlign: "left", fontSize: "13px" }}>Controle de Caixas</td>
                  <td><FaCheck size={26} color='green' /></td>
                  <td><FaCheck size={26} color='green' /></td>
                  <td><FaCheck size={26} color='green' /></td>
                  <td><FaCheck size={26} color='green' /></td>
                </tr>
                <tr>
                  <td style={{ textAlign: "left", fontSize: "13px" }}>Comandas, Orçamentos, Convênios</td>
                  <td>-</td>
                  <td><FaCheck size={26} color='green' /></td>
                  <td><FaCheck size={26} color='green' /></td>
                  <td><FaCheck size={26} color='green' /></td>
                </tr>
                <tr>
                  <td style={{ textAlign: "left", fontSize: "13px" }}>Gift-Card, Vale Presente</td>
                  <td>-</td>
                  <td><FaCheck size={26} color='green' /></td>
                  <td><FaCheck size={26} color='green' /></td>
                  <td><FaCheck size={26} color='green' /></td>
                </tr>
                <tr>
                  <td style={{ textAlign: "left", fontSize: "13px" }}>Criador de Etiquetas</td>
                  <td>-</td>
                  <td><FaCheck size={26} color='green' /></td>
                  <td><FaCheck size={26} color='green' /></td>
                  <td><FaCheck size={26} color='green' /></td>
                </tr>
                <tr>
                  <td style={{ textAlign: "left", fontSize: "13px" }}>Importador de XML e EXCEL (entradas)</td>
                  <td><FaCheck size={26} color='green' /></td>
                  <td><FaCheck size={26} color='green' /></td>
                  <td><FaCheck size={26} color='green' /></td>
                  <td><FaCheck size={26} color='green' /></td>
                </tr>
                <tr>
                  <td style={{ textAlign: "left", fontSize: "13px" }}>Criador de Listas de Produtos</td>
                  <td><FaCheck size={26} color='green' /></td>
                  <td><FaCheck size={26} color='green' /></td>
                  <td><FaCheck size={26} color='green' /></td>
                  <td><FaCheck size={26} color='green' /></td>
                </tr>
                <tr>
                  <td style={{ textAlign: "left", fontSize: "13px" }}><Tooltip title="Usamos um conjunto elaborado de sistemas para verificar os preços dos seus produtos pela internet e outros locais.">
                    <div style={{ width: "100%", position: "relative" }}>Verificador de Preços<div style={{ cursor: "help", position: "absolute", right: 0, top: 0, fontWeight: 700, color: "blue" }}>?</div></div></Tooltip></td>
                  <td>-</td>
                  <td>-</td>
                  <td>Por produto 1a1</td>
                  <td>Relatório geral e 1a1</td>
                </tr>
                <tr>
                  <td style={{ textAlign: "left", fontSize: "13px" }}>Cadastro automático de Livros</td>
                  <td>-</td>
                  <td><FaCheck size={26} color='green' /></td>
                  <td><FaCheck size={26} color='green' /></td>
                  <td><FaCheck size={26} color='green' /></td>
                </tr>
                <tr>
                  <td style={{ textAlign: "left", fontSize: "13px" }}>Controle de Consignados</td>
                  <td>-</td>
                  <td>F20 & C20</td>
                  <td>F80 & C80</td>
                  <td>F120 & C120</td>
                </tr>
                <tr>
                  <td style={{ textAlign: "left", fontSize: "13px" }}>Contas a Pagar e Receber</td>
                  <td>-</td>
                  <td><FaCheck size={26} color='green' /></td>
                  <td><FaCheck size={26} color='green' /></td>
                  <td><FaCheck size={26} color='green' /></td>
                </tr>
                <tr>
                  <td style={{ textAlign: "left", fontSize: "13px" }}>Portal de Acesso para Contador</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td><FaCheck size={26} color='green' /></td>
                </tr>
                <tr>
                  <td style={{ textAlign: "left", fontSize: "13px" }}>Sistema de Autorização para Descontos e Estornos</td>
                  <td>-</td>
                  <td>-</td>
                  <td><FaCheck size={26} color='green' /></td>
                  <td><FaCheck size={26} color='green' /></td>
                </tr>
                <tr>
                  <td style={{ textAlign: "left", fontSize: "13px" }}>Envio de Mercadorias entre Filiais</td>
                  <td>-</td>
                  <td>-</td>
                  <td><FaCheck size={26} color='green' /></td>
                  <td><FaCheck size={26} color='green' /></td>
                </tr>
                <tr>
                  <td style={{ textAlign: "left", fontSize: "13px" }}><Tooltip title="Cobre seus clientes via BOLETO ou PIX diretamente pela nossa plataforma. Cosulte os BANCOS suportados com um consultor.">
                    <div style={{ width: "100%", position: "relative" }}>Cobrança p/ Cliente. Boleto e PIX<div style={{ cursor: "help", position: "absolute", right: 0, top: 0, fontWeight: 700, color: "blue" }}>?</div></div></Tooltip></td>

                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td><FaCheck size={26} color='green' /></td>
                </tr>
                <tr>
                  <td style={{ textAlign: "left", fontSize: "13px" }}>Suporte</td>
                  <td style={{ fontSize: "13px" }}>Seg a Sex. 9h as 18h.</td>
                  <td style={{ fontSize: "12px" }}>Seg a Sex, 9h as 18h. Chamados emergenciais Sab.</td>
                  <td style={{ fontSize: "12px" }}>Seg a Sex, Sab. Chamados emergenciais Sab e Dom.</td>
                  <td style={{ fontSize: "12px" }}>Seg a Sex, Sab. Chamados emergenciais Sab e Dom.</td>
                </tr>
              </tbody>
            </table>
          </div>


          <div style={{ border: "1px solid black", borderRadius: "10px", maxHeight: "274px" }}>
            <p style={{ margin: "10px", fontSize: "15px" }} >Complementos e Adicionais (mensal por loja)</p>

            <table style={{ width: "340px", height: "auto" }}>

              <tbody>
                <tr>
                  <td style={{ textAlign: "left" }}>Dispositivo Adicional</td>
                  <td style={{ width: "100px" }}>R$ 15,00</td>
                </tr>
                <tr>
                  <td style={{ textAlign: "left" }}>Loja Adicional (+1 dispositivo)</td>
                  <td>R$ 45,00</td>
                </tr>
                <tr>
                  <td style={{ textAlign: "left" }}>TEF APP Integração Pagamento (Vero, PagSeguro, Stone)</td>
                  <td>R$ 15,00</td>
                </tr>
                <tr>
                  <td style={{ textAlign: "left" }}>TEF Integração para PIN-PAD</td>
                  <td>R$ 135,00</td>
                </tr>
                <tr>
                  <td style={{ textAlign: "left" }}>Controle de Agendamentos</td>
                  <td>R$ 15,00</td>
                </tr>
                <tr>
                  <td style={{ textAlign: "left" }}>Emissão Nota de Serviço (Guaíba/RS) NFSe</td>
                  <td>R$ 15,00</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* 
       
          <div style={{width:"100%",  height: isMobile ? "auto" : "490px", backgroundColor:"rgba(255, 255, 255, 0.9)",display:"flex", gap:"25px", 
          justifyContent:"center", alignItems:"start", flexWrap:"wrap",   padding:isMobile ? "25px" : null}}>
           
            <div style={{width:"250px", height:"auto", border:"1px solid black", backgroundColor:"rgba(248, 242, 254, 0.9)", overflow:"hidden", marginTop:"25px",
                        minHeight:"300px", borderRadius:"18px", }}>

              <div style={{height:"40px", width:"100%", display:"flex",
                          backgroundColor:"rgba(131, 91, 184, 0.9)",
                          alignItems:"center", justifyContent:"center", color:"white", fontSize:"18px",}}> Micro </div>
              
              
              <div style={{height:"30px", width:"100%",display:"flex", alignItems:"center", padding:"15px", color:"white", 
                          justifyContent:"center",  backgroundColor:"rgba(131, 91, 184, 0.9)", gap:"5px"}}>
                            <s>R$ 55,00</s> por 
                            <strong >R$ 45,00</strong><p style={{color:"rgb(224, 224, 224)", fontSize:"10px"}}>mês</p></div>
              <div style={{display:"flex", flexDirection:"column", gap:"7px", padding:"10px",}}>
                { novoItem(1, "Uso em 2 dispositivos", "Você pode adicionar mais dispositivos") }
                { novoItem(3, "Limite de 2 usuários", "Não é possível adicionar mais usuários neste plano") }
                { novoItem(3, "Limite de 500 produtos","Limite de cadastros de produtos") }
                { novoItem(1, "Suporte Seg a Sex", "Em horário comercial") }
              </div>
              <div style={{display:"flex", flexDirection:"row", flexWrap:"wrap", gap:"7px", padding:"10px",}}>
                <div style={{width:"100%", textAlign:"center"}}>Recursos</div>
                { novoModulo("Caixa (tipo PDV)", "") }
                { novoModulo("NFCe, NFe, NFSe", "") }
                { novoModulo("Controle de Estoque", "") }
                { novoModulo("Encomendas", "") }
                { novoModulo("Etiquetas", "") }
                { novoModulo("Ficha Cliente", "") }
                { novoModulo("Listas", "") }
                { novoModulo("Controle de Caixas", "") }
                { novoModulo("Importador de XML/Excel", "") }
                { novoModulo("Orçamentos", "") }     
              </div>
              
            </div>

            <div style={{width:"250px", height:"auto", border:"1px solid black", backgroundColor:"rgba(248, 242, 254, 0.9)", overflow:"hidden", marginTop:"25px",
                        minHeight:"300px", borderRadius:"18px", }}>

              <div style={{height:"40px", width:"100%", display:"flex",
                          backgroundColor:"rgba(131, 91, 184, 0.9)",
                          alignItems:"center", justifyContent:"center", color:"white", fontSize:"18px",}}> Médio </div>
              <div style={{height:"30px", width:"100%",display:"flex", alignItems:"center", padding:"15px", color:"white", 
                          justifyContent:"center",  backgroundColor:"rgba(131, 91, 184, 0.9)", gap:"5px" }}>
                            <s>R$ 75,00</s> por 
                            <strong>R$ 65,00</strong><p style={{color:"rgb(224, 224, 224)", fontSize:"10px"}}>mês</p></div>
              <div style={{display:"flex", flexDirection:"column", gap:"7px", padding:"10px",}}>
                { novoItem(2, "Uso em 3 dispositivos", "Você pode adicionar mais dispositivos") }
                { novoItem(2, "Sem limite de usuários") }
                { novoItem(3, "Limite de 20.000 produtos","Limite de cadastros de produtos") }
                { novoItem(1, "Multi Loja (até 2 lojas)", "Cada loja irá custar 45,00 por mês e irá adicionar +3 dispositivos.","+45,00 cada") }
                { novoItem(1, "Suporte Seg a Sex, Sáb.", "Em horário comercial") }
              </div>
              <div style={{display:"flex", flexDirection:"row", flexWrap:"wrap", gap:"7px", padding:"10px",}}>
                <div style={{width:"100%", textAlign:"center"}}>Recursos</div>
                { novoModulo("+ Recursos do Micro", "") }
                { novoModulo("Controle de Consignados, F20 e C20", "Limitado até 20 Fornecedores e 20 Clientes") }
                { novoModulo("Contas a Pagar e Receber", "") }
                { novoModulo("Verificador de Preços", "Usamos um conjunto elaborado de sistemas para verificar os preços dos seus produtos pela internet e outros locais.") }
                { novoModulo("Cadastro Automático de Livros", "Nós já temos o cadastro de grande parte dos livros nacionais, podendo agilizar o proecsso de cadastros de livros em seu estoque.") }
                { novoModulo("Comandas", "") }
                { novoModulo("Convênios", "") }   
                { novoModulo("Vale-Presente", "") }
              </div>
            </div>

            <div style={{width:"250px", height:"auto", border:"1px solid black", backgroundColor:"rgba(248, 242, 254, 0.9)", overflow:"hidden", marginTop:"25px",
                        minHeight:"300px", borderRadius:"18px", }}>

              <div style={{height:"40px", width:"100%", display:"flex",
                          backgroundColor:"rgba(131, 91, 184, 0.9)",
                          alignItems:"center", justifyContent:"center", color:"white", fontSize:"18px",}}> Pró </div>
              <div style={{height:"30px", width:"100%",display:"flex", alignItems:"center", padding:"15px", color:"white", 
                          justifyContent:"center",  backgroundColor:"rgba(131, 91, 184, 0.9)", gap:"5px" }}>
                            <s>R$ 95,00</s> por 
                            <strong>R$ 85,00</strong><p style={{color:"rgb(224, 224, 224)", fontSize:"10px"}}>mês</p></div>
              <div style={{display:"flex", flexDirection:"column", gap:"7px", padding:"10px",}}>
                { novoItem(2, "Uso em 3 dispositivos", "Você pode adicionar mais dispositivos") }
                { novoItem(2, "Sem limite de usuários") }
                { novoItem(3, "Limite de 20.000 produtos","Limite de cadastros de produtos") }
                { novoItem(1, "Multi Loja (até 2 lojas)", "Cada loja irá custar 45,00 por mês e irá adicionar +3 dispositivos.","+45,00 cada") }
                { novoItem(1, "Suporte Seg a Sex, Sáb.", "Em horário comercial") }
              </div>
              <div style={{display:"flex", flexDirection:"row", flexWrap:"wrap", gap:"7px", padding:"10px",}}>
                <div style={{width:"100%", textAlign:"center"}}>Recursos</div>
                { novoModulo("+ Recursos do Micro", "") }
                { novoModulo("Controle de Consignados, F20 e C20", "Limitado até 20 Fornecedores e 20 Clientes") }
                { novoModulo("Contas a Pagar e Receber", "") }
                { novoModulo("Verificador de Preços", "Usamos um conjunto elaborado de sistemas para verificar os preços dos seus produtos pela internet e outros locais.") }
                { novoModulo("Cadastro Automático de Livros", "Nós já temos o cadastro de grande parte dos livros nacionais, podendo agilizar o proecsso de cadastros de livros em seu estoque.") }
                { novoModulo("Comandas", "") }
                { novoModulo("Convênios", "") }   
                { novoModulo("Vale-Presente", "") }
              </div>
            </div>


            <div style={{width:"250px", height:"auto", border:"1px solid black", backgroundColor:"rgba(248, 242, 254, 0.9)", overflow:"hidden",marginTop:"25px",
                        minHeight:"300px", borderRadius:"18px", }}>

              <div style={{height:"40px", width:"100%", display:"flex",
                          backgroundColor:"rgba(131, 91, 184, 0.9)",
                          alignItems:"center", justifyContent:"center", color:"white", fontSize:"18px",}}> Nano </div>
              <div style={{height:"30px", width:"100%",display:"flex", alignItems:"center", padding:"15px", color:"white", 
                          justifyContent:"center",  backgroundColor:"rgba(131, 91, 184, 0.9)", gap:"5px" }}>
                            <strong>R$ 30,00</strong><p style={{color:"rgb(224, 224, 224)", fontSize:"10px"}}>mês</p></div>
              <div style={{display:"flex", flexDirection:"column", gap:"7px", padding:"10px",}}>
                { novoItem(1, "Uso em 1 dispositivo", "Você pode adicionar mais dispositivos") }
                { novoItem(3, "Uso em até 1 usuário", "Não é possível adicionar mais usuários neste plano") }
                { novoItem(3, "Limite de 50 produtos","Limite de cadastros de produtos") }
                { novoItem(3, "Limite de 100 NFs ao mês", "Limite de emissão de notas fiscais.") }
                { novoItem(1, "Suporte por chamado","Retorno em até 24h em dias úteis.") }
              </div>
              <div style={{display:"flex", flexDirection:"row", flexWrap:"wrap", gap:"7px", padding:"10px",}}>
                <div style={{width:"100%", textAlign:"center"}}>Recursos</div>
                { novoModulo("Caixa (tipo PDV)", "") }
                { novoModulo("NFCe, NFSe", "Consulte a lista de cidades para NFSe") }
                { novoModulo("Controle de Estoque", "") }
                { novoModulo("Controle de Caixas", "") }
              </div>
            </div>
          </div>
    


          <div style={{width:"100%", textAlign:"center", backgroundColor:"rgba(108, 58, 173, 0.9)", padding:"15px", color:"white", fontSize:"20px"}} >Complementos e Adicionais</div>
          <div style={{width:"100%",  padding:"25px", height: isMobile ? "auto" : "250px", backgroundColor:"rgba(108, 58, 173, 0.9)",display:"flex", 
                      flexWrap:"wrap", gap:"25px", justifyContent:"center", alignItems:"center"}}>
           
           <div style={{width:"250px", height:"auto", border:"1px solid black", backgroundColor:"rgba(248, 242, 254, 0.9)", overflow:"hidden", 
                        borderRadius:"18px", minHeight:"160px",}}>

             <div style={{height:"40px", width:"100%", display:"flex",
                         backgroundColor:"rgba(131, 91, 184, 0.9)",
                         alignItems:"center", justifyContent:"center", color:"white", fontSize:"18px",}}> Dispositivo Adicional </div>
             <div style={{height:"30px", width:"100%",display:"flex", alignItems:"center", padding:"15px", color:"white", 
                         justifyContent:"center",  backgroundColor:"rgba(131, 91, 184, 0.9)", }}>
                           <strong>R$ 15,00</strong><p style={{color:"rgb(224, 224, 224)", fontSize:"10px", marginLeft:"4px"}}>mês</p></div>
                           <div style={{display:"flex", flexDirection:"column", gap:"7px", padding:"10px",textAlign:"center"}}>
                Adicione mais um computador, notebook, tablet, celular.
              </div>
           </div>

           <div style={{width:"250px", height:"auto", border:"1px solid black", backgroundColor:"rgba(248, 242, 254, 0.9)", overflow:"hidden", 
                        borderRadius:"18px",  minHeight:"160px", }}>

             <div style={{height:"40px", width:"100%", display:"flex",
                         backgroundColor:"rgba(131, 91, 184, 0.9)",
                         alignItems:"center", justifyContent:"center", color:"white", fontSize:"18px",}}> Smart APP - Pagamentos </div>
             <div style={{height:"30px", width:"100%",display:"flex", alignItems:"center", padding:"15px", color:"white", 
                         justifyContent:"center",  backgroundColor:"rgba(131, 91, 184, 0.9)", }}>
                           <strong>R$ 15,00</strong><p style={{color:"rgb(224, 224, 224)", fontSize:"10px", marginLeft:"4px"}}>mês</p></div>
             <div style={{display:"flex", flexDirection:"column", gap:"7px", padding:"10px",textAlign:"center"}}>
             Aplicativo para máquinas de pagamento smart. Compatível com PagSeguro, Stone, Banrisul (vero), e Cielo
              </div>
           </div>

         </div>
      */}



        <div style={{ height: "45px", width: "100%", backgroundColor: "#7c797974", display: "flex", color: "white", gap: "25px", padding: "15px", alignItems: "center" }}>
          <p>BeiTec ® 2024 </p>
          <p>32.411.090/0001-08</p>

        </div>
      </div>

    </>
  )
}
